import React from 'react';
import { NewsSubsectionsInput, type NewsSubsection } from './NewsSubsectionsInput';

interface NewsSubsectionsFieldProps {
  label: string;
  required?: boolean;
  value: NewsSubsection[];
  onChange: (_sections: NewsSubsection[]) => void;
  error?: string;
}

export const NewsSubsectionsField: React.FC<NewsSubsectionsFieldProps> = ({
  label,
  required,
  value,
  onChange,
  error,
}) => {
  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-700">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <NewsSubsectionsInput value={value ?? []} onChange={onChange} />
      {error && <p className="text-red-500 text-sm">{error}</p>}
    </div>
  );
};
